import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lh-1" }

import {computed, ref} from 'vue';
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {__} from "~/ts/library/Translate";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import ObjectHelper from "~/ts/library/ObjectHelper";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import getOperatorDisplayName from "~/operatorApplication/ts/service/operators/getOperatorDisplayName";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";
import MyDatePicker from "~/core-ui/vue/ui/MyDatePicker.vue";


import OperatorConfigOpenApiModel = OperatorApplicationApi.OperatorConfigOpenApiModel;

const __default__ = {
    name: "OperatorApplicationServerSideConfig"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let configuration = computed(() => {
    return OperatorApplicationConfigInstance;
});

let model = ref(ObjectHelper.jsonClone(OperatorAccountStore.data.value.settings));

let showReplaceConfig = computed(() => !!OperatorAccountStore.data.value.sites.find(site => site.isPermanentAttachClientToOperators));

async function save() {
    let p: OperatorConfigOpenApiModel = model.value;
    (new OperatorApiRequest({
        url: "/operator/saveConfig",
        p
    })).save()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      "label-position": "left",
      "label-width": "200px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(__)('Язык для перевода')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(model).languageIsoCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).languageIsoCode) = $event)),
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OperatorAccountStore).data.value.languages, (language) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: language.id,
                    value: language.id,
                    label: language.descr
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(HelpBlock, { warning: "" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)("После смены языка для перевода требуется перезайти в приложение, чтобы обновить уже переведенные сообщения")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(__)('Язык для диктовки')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(model).dictationLanguageIsoCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).dictationLanguageIsoCode) = $event)),
              filterable: "",
              clearable: "",
              placeholder: "Определять автоматически"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OperatorAccountStore).data.value.languages, (language) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: language.id,
                    value: language.id,
                    label: language.descr
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(OperatorAccountStore).data.value.accessRights.canVacationConfig)
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
              label: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_switch, {
                    modelValue: _unref(model).vacation.enabled,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).vacation.enabled) = $event))
                  }, null, 8, ["modelValue"]),
                  _createTextVNode(" " + _toDisplayString(_unref(__)('Отпуск включен')), 1)
                ])
              ]),
              default: _withCtx(() => [
                (_unref(model).vacation.enabled)
                  ? (_openBlock(), _createBlock(_component_el_form, {
                      key: 0,
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(__)('Период отпуска'),
                          class: "mt-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(MyDatePicker, {
                              modelValue: _unref(model).vacation.dateRange.start,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).vacation.dateRange.start) = $event)),
                              style: {"width":"140px"},
                              class: "text-center"
                            }, null, 8, ["modelValue"]),
                            _createVNode(FontAwesomeIcon, {
                              icon: "ellipsis-h",
                              class: "mr-2 ml-2"
                            }),
                            _createVNode(MyDatePicker, {
                              modelValue: _unref(model).vacation.dateRange.stop,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).vacation.dateRange.stop) = $event)),
                              style: {"width":"140px"},
                              class: "text-center"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        (_unref(showReplaceConfig))
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              label: _unref(__)('Сменщики')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _unref(model).vacation.replacerLogins,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(model).vacation.replacerLogins) = $event)),
                                  multiple: "",
                                  class: "w-100"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OperatorAccountStore).data.value.operators, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.login,
                                        value: item.login,
                                        label: _unref(getOperatorDisplayName)(item)
                                      }, null, 8, ["value", "label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: save
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)("Сохранить")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})